import { Helmet } from "react-helmet-async";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Hero from "../components/sections/Hero";
import BoatsSection from "../components/sections/BoatsSection";
import ExperienceSection from "../components/sections/ExperienceSection";
import LocationSection from "../components/sections/LocationSection";
import ContactSection from "../components/sections/ContactSection";
import ReviewsSection from "../components/sections/ReviewsSection";
import PromiseSection from "../components/sections/PromiseSection";

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-[#FAFAF8] text-[#1C1C1A] min-h-screen">
      <Helmet>
        <title>Houseboat Stay on Lough Ree, Athlone | Aquastays</title>
        <meta name="description" content="Boutique houseboat on Lough Ree with two private decks, full kitchen and self check-in. From €180/night, 75 min from Dublin." />
        <link rel="canonical" href="https://aquastays.com" />
        <meta property="og:url" content="https://aquastays.com" />
        <meta property="og:title" content="Houseboat Stay on Lough Ree, Athlone | Aquastays" />
        <meta property="og:description" content="Boutique houseboat on Lough Ree with two private decks, full kitchen and self check-in. From €180/night, 75 min from Dublin." />
      </Helmet>
      <Header />
      <main>
        <Hero />
        <BoatsSection />
        <ExperienceSection />
        <PromiseSection />
        <ReviewsSection />
        <LocationSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
